export default "__VITE_ASSET__DZMzcVYH__"